import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface MakeDTO extends BaseIntDTO {
  makeName: string;
  vehicleTypeId: number;
}
